// extracted by mini-css-extract-plugin
export default {"buttons":"ItemCount_buttons__-9Ixj","contador":"ItemCount_contador__r0j7I","buttonMenos":"ItemCount_buttonMenos__ux4b-","buttonMas":"ItemCount_buttonMas__uwYnv"};